import { OverlayRef, Overlay, FlexibleConnectedPositionStrategy, ConnectedPosition } from "@angular/cdk/overlay";
import { TemplatePortal } from "@angular/cdk/portal";
import { Injectable, ElementRef, TemplateRef, ViewContainerRef } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable({
    providedIn: 'root',
  })
  export class OverlayService {
    private  overlayRef: OverlayRef | null = null;

    constructor(private readonly  overlay: Overlay) {}

    open(
      origin: ElementRef,
      template: TemplateRef<any>,
      viewContainerRef: ViewContainerRef,
      positions: ConnectedPosition[],
      originWidth: boolean,
      context?: any,
    ): Observable<void> {
      this.close();

      const closed$ = new Subject<void>();

      const positionStrategy: FlexibleConnectedPositionStrategy = this.overlay
        .position()
        .flexibleConnectedTo(origin)
        .withPositions(positions);

      this.overlayRef = this.overlay.create({
        positionStrategy,
        hasBackdrop: true,
        backdropClass: 'cdk-overlay-transparent-backdrop',
        scrollStrategy: this.overlay.scrollStrategies.reposition()
      });

      const portal = new TemplatePortal(template, viewContainerRef, { $implicit: context });

      this.overlayRef.attach(portal);

      if (originWidth) {
        this.overlayRef.updateSize({ width: origin.nativeElement.offsetWidth });
      }

      this.overlayRef.backdropClick().subscribe(() => {
        this.close();
        closed$.next();
        closed$.complete();
      });

      return closed$.asObservable();
    }

    close() {
      if (this.overlayRef) {
        this.overlayRef.dispose();
        this.overlayRef = null;
      }
    }
  }
